import "./ToggleButton.scss";
import { useState } from "react";

const Toggle = ({ toggled, onClick }) => {
  const [isToggled, toggle] = useState(toggled);

  const callback = () => {
    const newToggle = !isToggled;
    toggle(newToggle);
    onClick(newToggle);
    onClick("status", newToggle);
  };

  return (
    <label className="toggle-btn">
      <input
        className="toggle-input"
        type="checkbox"
        defaultChecked={isToggled}
        onClick={callback}
      />
      <span className="toggle-span" />
    </label>
  );
};

export default Toggle;
